import type { PaintProduct, RGB } from '@modules/paint-picker-new/type';
import { calculateColourAtPoint } from '@modules/paint-picker-new/util/paint-picker-util';

export const usedRandomPaintFromImage = (
    canvas: HTMLCanvasElement,
    colourMatchFunc: (rgb: RGB) => PaintProduct | null,
    numOfPaints: number,
    activeImageSrc: string
): PaintProduct[] => {
    let paints: PaintProduct[] = [];
    let amountToCreate = numOfPaints;
    let retries = 0;

    while (amountToCreate > 0 && retries <= 5) {
        const x = Math.floor(Math.random() * canvas.width);
        const y = Math.floor(Math.random() * canvas.height);
        const colour = calculateColourAtPoint(x, y, canvas);
        if (colour) {
            const paint = colourMatchFunc(colour);

            // we want unique paint products
            if (paint && !paints.find((c) => c.id === paint.id)) {
                const selectionPaint = {
                    ...paint,
                    fromImageUrl: activeImageSrc,
                };
                paints.push(selectionPaint);
                amountToCreate--;
                continue;
            }
        }

        // return up to 5 times if the random colour results to existing matched paint products.
        retries++;
    }

    return paints;
};
